import arrayParser from "../arrayParser"

const chestExaminationProcessor=(element)=>
{
let assembledElement=" concerning"
if (element["Side"] !== "")
    {
    if (element["Side"] === "Bilateral")
        {
        assembledElement += " bilateral"
        }
    else
        {
        assembledElement += ` ${element["Side"].toLowerCase()} sided`
        }
    }
assembledElement += " findings on chest examination"

if (element["Inspection"].length !== 0)
    {
    let inspectionFindings = (arrayParser(element["Inspection"]).toLowerCase())
    assembledElement += ` including ${inspectionFindings}`
    }

if (element["Palpation"].length !== 0)
{
let inspectionFindings = (arrayParser(element["Palpation"]).toLowerCase())
assembledElement += `.  On palpation there was ${inspectionFindings}`
}


if (element["Percussion"].length !== 0)
    {
    let percussionFindings = (arrayParser(element["Percussion"]).toLowerCase())
    assembledElement += `.  Percussion revealed ${percussionFindings}`
    }

if (element["Ausculation"].length !== 0)
    {
    if (element["Percussion"].length !== 0)
        {
        assembledElement += ".  Auscultation revealed"
        }
    else
        {
        assembledElement += " and on ausculation there was"
        }
    let ausculationFindings = (arrayParser(element["Ausculation"]).toLowerCase())
    assembledElement += ` ${ausculationFindings}`
    }

if (element["Any_other_findings"] !== "")
    {
    assembledElement += `.  Additional examination findings were ${element["Any_other_findings"]}`
    }



return (assembledElement)
}

export default chestExaminationProcessor